import { render, staticRenderFns } from "./EditableObject.vue?vue&type=template&id=46c20c6f&scoped=true&"
import script from "./EditableObject.vue?vue&type=script&lang=js&"
export * from "./EditableObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c20c6f",
  null
  
)

export default component.exports